import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "search-aside" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", { class: "margin-none" }, "Search Settings", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Filter by document status: ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("All")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Open")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Closed")
const _hoisted_9 = { key: 2 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Filter by Test Drive status: ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("All")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Yes")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("No")
const _hoisted_14 = { key: 3 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Filter by user status: ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("All")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Active")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Terminated")
const _hoisted_19 = { key: 4 }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Filter by integration: ")
const _hoisted_21 = { key: 5 }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Filter by user group: ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Driver")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Customer Admin")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Value-Added Reseller")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Admin")
const _hoisted_27 = { key: 6 }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Filter by groups: ")
const _hoisted_29 = { key: 7 }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Filter by tags: ")
const _hoisted_31 = { class: "margin-vert" }
const _hoisted_32 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Add Query")
const _hoisted_36 = /*#__PURE__*/_createTextVNode()
const _hoisted_37 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_38 = { class: "margin-vert" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Items must match: ")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("All Tag Filters")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Some Tag Filters")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_button = _resolveComponent("el-button")
  const _component_TagQuery = _resolveComponent("TagQuery")
  const _component_el_container = _resolveComponent("el-container")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_container, { direction: "vertical" }, {
      default: _withCtx(() => [
        (_ctx.useSearch)
          ? (_openBlock(), _createBlock("span", _hoisted_3, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.search,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.search = $event)),
                placeholder: "Search Entries",
                class: "margin-vert",
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchChangeHandler(_ctx.search)))
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.useStatusReports)
          ? (_openBlock(), _createBlock("span", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.statusFilter,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.statusFilter = $event)),
                onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.statusFilterHandler(_ctx.statusFilter))),
                class: "margin-vert"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    modelValue: _ctx.statusFilter,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.statusFilter = $event)),
                    label: "all"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_radio, {
                    modelValue: _ctx.statusFilter,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.statusFilter = $event)),
                    label: "active"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_radio, {
                    modelValue: _ctx.statusFilter,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.statusFilter = $event)),
                    label: "deleted"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.useTrainingStatus)
          ? (_openBlock(), _createBlock("span", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.trainingStatusFilter,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.trainingStatusFilter = $event)),
                onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.trainingStatusFilterHandler(_ctx.trainingStatusFilter))),
                class: "margin-vert"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    modelValue: _ctx.statusFilter,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.statusFilter = $event)),
                    label: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_radio, {
                    modelValue: _ctx.statusFilter,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.statusFilter = $event)),
                    label: "1"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_radio, {
                    modelValue: _ctx.statusFilter,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.statusFilter = $event)),
                    label: "0"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.useStatusUsers)
          ? (_openBlock(), _createBlock("span", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.statusFilter,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.statusFilter = $event)),
                onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.statusFilterHandler(_ctx.statusFilter))),
                class: "margin-vert"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    modelValue: _ctx.statusFilter,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.statusFilter = $event)),
                    label: "all"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_radio, {
                    modelValue: _ctx.statusFilter,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.statusFilter = $event)),
                    label: "active"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_radio, {
                    modelValue: _ctx.statusFilter,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.statusFilter = $event)),
                    label: "deleted"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_18
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.useIntegration)
          ? (_openBlock(), _createBlock("span", _hoisted_19, [
              _hoisted_20,
              _createVNode(_component_el_select, {
                modelValue: _ctx.integration,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.integration = $event)),
                placeholder: "Select an Integration",
                onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.integrationChangeHandler(_ctx.integration))),
                class: "margin-vert"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.integrationOptions, (option) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: option.key,
                      label: option.value,
                      value: option.key
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.useUserGroups)
          ? (_openBlock(), _createBlock("span", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_el_checkbox_group, {
                modelValue: _ctx.groupFilter,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.groupFilter = $event)),
                onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.groupFilterHandler(_ctx.groupFilter))),
                class: "margin-vert"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox, {
                    label: "driver",
                    key: "driver"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_23
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_checkbox, {
                    label: "customer-admin",
                    key: "customer-admin"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_24
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_checkbox, {
                    label: "value-added-resaler",
                    key: "value-added-resaler"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_25
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_checkbox, {
                    label: "admin",
                    key: "admin"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_26
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.useOrganizationGroups)
          ? (_openBlock(), _createBlock("span", _hoisted_27, [
              _hoisted_28,
              _createVNode(_component_el_select, {
                modelValue: _ctx.organizationGroup,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.organizationGroup = $event)),
                placeholder: "Select an Group",
                onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.organizationGroupChangeHandler(_ctx.organizationGroup))),
                class: "margin-vert"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    key: "",
                    label: "Any Group",
                    value: ""
                  }),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.organizationGroupValues, (option) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: option,
                      label: option,
                      value: option
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.useTags)
          ? (_openBlock(), _createBlock("span", _hoisted_29, [
              _hoisted_30,
              _createVNode("div", _hoisted_31, [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.newQueryKey,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.newQueryKey = $event)),
                  placeholder: "Tag Name",
                  filterable: "",
                  onChange: _ctx.handleTagNameSelect,
                  class: "full-width"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.allTags, (tag) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: tag.key,
                        label: tag.key,
                        value: tag.key
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"]),
                _hoisted_32,
                _createVNode(_component_el_select, {
                  modelValue: _ctx.newQueryCondition,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.newQueryCondition = $event)),
                  placeholder: "Condition",
                  class: "full-width"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.possibleConditions, (condition) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: condition,
                        label: _ctx.getConditionName(condition),
                        value: condition
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _hoisted_33,
                (_ctx.newQueryType !== 'boolean')
                  ? (_openBlock(), _createBlock(_component_el_input, {
                      key: 0,
                      modelValue: _ctx.newQueryValue,
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.newQueryValue = $event)),
                      placeholder: "Value",
                      class: "full-width"
                    }, null, 8, ["modelValue"]))
                  : (_openBlock(), _createBlock(_component_el_select, {
                      key: 1,
                      modelValue: _ctx.newQueryValue,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.newQueryValue = $event)),
                      placeholder: "Value",
                      class: "full-width"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.boolVals, (val) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: val,
                            label: val,
                            value: val
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])),
                _hoisted_34,
                _createVNode(_component_el_button, { onClick: _ctx.addNewTagQuery }, {
                  default: _withCtx(() => [
                    _hoisted_35
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _hoisted_36,
                _hoisted_37,
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tagQueries, (query, index) => {
                  return (_openBlock(), _createBlock("span", {
                    key: query.key
                  }, [
                    _createVNode(_component_TagQuery, {
                      name: query.key,
                      condition: query.condition,
                      value: query.value,
                      onClick: ($event: any) => (_ctx.removeTagQuery(index))
                    }, null, 8, ["name", "condition", "value", "onClick"])
                  ]))
                }), 128)),
                _createVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createVNode(_component_el_radio_group, {
                    modelValue: _ctx.tagMatch,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.tagMatch = $event)),
                    onChange: _cache[31] || (_cache[31] = ($event: any) => (_ctx.tagMatchHandler(_ctx.tagMatch)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, {
                        modelValue: _ctx.tagMatch,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.tagMatch = $event)),
                        label: "all"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_40
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_radio, {
                        modelValue: _ctx.tagMatch,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.tagMatch = $event)),
                        label: "some"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_41
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}